enum AccountStatuses {
  Active = 'active',
  Suspended = 'suspended',
  Disabled = 'disabled'
};

export default AccountStatuses;
